<div class="category-plp-loading">
  <ng-container *ngIf="isMobile">
    <div fxLayout="row">
      <!-- Headline Banner -->
      <ngx-skeleton-loader
        class="category-plp-loading__full-width"
        animation="progress"
        [theme]="{ 'height.px': 90 }"
      ></ngx-skeleton-loader>
    </div>

    <div fxLayout="row">
      <!-- Sub Category Grid -->
      <ngx-skeleton-loader
        animation="progress"
        count="3"
        [theme]="{ 'height.px': 114, 'width.px': 109, 'margin.px': 8 }"
      ></ngx-skeleton-loader>
    </div>

    <div fxLayout="row">
      <!-- Advanced carousel -->
      <ngx-skeleton-loader
        class="category-plp-loading__full-width"
        animation="progress"
        [theme]="{ 'height.px': 375 }"
      ></ngx-skeleton-loader>
    </div>

    <div fxLayout="row">
      <!-- Brand List -->
      <ngx-skeleton-loader
        class="category-plp-loading__full-width"
        animation="progress"
        [theme]="{ 'height.px': 250 }"
      ></ngx-skeleton-loader>
    </div>

    <!-- USP Grid -->
    <div class="category-plp-loading__usp-grid">
      <div fxLayout="row">
        <ngx-skeleton-loader
          animation="progress"
          [theme]="{ 'height.px': 30, 'width.px': '200', 'margin.px': 8 }"
        ></ngx-skeleton-loader>
      </div>
      <div fxLayout="row">
        <ngx-skeleton-loader
          animation="progress"
          [theme]="{ 'height.px': 20, 'width.px': '200', 'margin.px': 8 }"
        ></ngx-skeleton-loader>
      </div>
      <div fxLayout="row">
        <ngx-skeleton-loader
          animation="progress"
          [theme]="{ 'height.px': 20, 'width.px': '100', 'margin.px': 8 }"
        ></ngx-skeleton-loader>
      </div>
      <div fxLayout="row">
        <ngx-skeleton-loader
          animation="progress"
          [theme]="{ 'height.px': 130, 'width.px': '100', 'margin.px': 8 }"
          count="3"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isTablet">
    <div fxLayout="row">
      <!-- Headline Banner -->
      <ngx-skeleton-loader
        class="category-plp-loading__full-width"
        animation="progress"
        [theme]="{ 'height.px': 132 }"
      ></ngx-skeleton-loader>
    </div>

    <div fxLayout="row">
      <!-- Sub Category Grid -->
      <ngx-skeleton-loader
        animation="progress"
        count="4"
        [theme]="{ 'height.px': 150, 'width.px': 180, 'margin.px': 8 }"
      ></ngx-skeleton-loader>
    </div>

    <div fxLayout="row">
      <!-- Advanced carousel -->
      <ngx-skeleton-loader
        class="category-plp-loading__full-width"
        animation="progress"
        [theme]="{ 'height.px': 355 }"
      ></ngx-skeleton-loader>
    </div>

    <div fxLayout="row">
      <!-- Brand List -->
      <ngx-skeleton-loader
        class="category-plp-loading__full-width"
        animation="progress"
        [theme]="{ 'height.px': 190 }"
      ></ngx-skeleton-loader>
    </div>

    <!-- USP Grid -->
    <div class="category-plp-loading__usp-grid">
      <div fxLayout="row">
        <ngx-skeleton-loader
          animation="progress"
          [theme]="{ 'height.px': 36, 'width.px': '224', 'margin.px': 8 }"
        ></ngx-skeleton-loader>
      </div>
      <div fxLayout="row">
        <ngx-skeleton-loader
          animation="progress"
          [theme]="{ 'height.px': 20, 'width.px': '600', 'margin.px': 8 }"
        ></ngx-skeleton-loader>
      </div>
      <div fxLayout="row">
        <ngx-skeleton-loader
          animation="progress"
          [theme]="{ 'height.px': 20, 'width.px': '400', 'margin.px': 8 }"
        ></ngx-skeleton-loader>
      </div>
      <div fxLayout="row">
        <ngx-skeleton-loader
          animation="progress"
          [theme]="{ 'height.px': 170, 'width.px': '250', 'margin.px': 8 }"
          count="3"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isDesktop || isLandScapeTablet">
    <div fxLayout="row">
      <!-- Headline Banner -->
      <ngx-skeleton-loader
        class="category-plp-loading__full-width"
        animation="progress"
        [theme]="{ 'height.px': 130, 'margin.px': 8 }"
      ></ngx-skeleton-loader>
    </div>

    <div fxLayout="row">
      <!-- Sub Category Grid -->
      <ngx-skeleton-loader
        animation="progress"
        count="5"
        [theme]="{ 'height.px': 85, 'width.px': 250, 'margin.px': 8 }"
      ></ngx-skeleton-loader>
    </div>

    <div fxLayout="row">
      <!-- Advanced carousel -->
      <ngx-skeleton-loader
        class="category-plp-loading__full-width"
        animation="progress"
        [theme]="{ 'height.px': 300, 'margin.px': 8 }"
      ></ngx-skeleton-loader>
    </div>

    <div fxLayout="row">
      <!-- Brand List -->
      <ngx-skeleton-loader
        class="category-plp-loading__full-width"
        animation="progress"
        [theme]="{ 'height.px': 190, 'margin.px': 8 }"
      ></ngx-skeleton-loader>
    </div>

    <!-- USP Grid -->
    <div class="category-plp-loading__usp-grid">
      <div fxLayout="row">
        <ngx-skeleton-loader
          animation="progress"
          [theme]="{ 'height.px': 36, 'width.px': '224', 'margin.px': 8 }"
        ></ngx-skeleton-loader>
      </div>
      <div fxLayout="row">
        <ngx-skeleton-loader
          animation="progress"
          [theme]="{ 'height.px': 20, 'width.px': '600', 'margin.px': 8 }"
        ></ngx-skeleton-loader>
      </div>
      <div fxLayout="row">
        <ngx-skeleton-loader
          animation="progress"
          [theme]="{ 'height.px': 20, 'width.px': '600', 'margin.px': 8 }"
        ></ngx-skeleton-loader>
      </div>
      <div fxLayout="row">
        <ngx-skeleton-loader
          animation="progress"
          [theme]="{ 'height.px': 110, 'width.px': '450', 'margin.px': 8 }"
          count="3"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </ng-container>
</div>
